import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/react";

const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
const tracesSampleRate = parseFloat(
  (import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE as string) || "0.1"
);

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_SENTRY_RELEASE as string | undefined,
    tracesSampleRate,
    sendDefaultPii: false,
    integrations: [browserTracingIntegration()],
  });
}

export { Sentry };
export const sentryEnabled = !!dsn;
